





import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import CargaDenuncias from './CargaDenuncias.vue'

@Component({
  components: { CargaDenuncias },
})
export default class Denuncias extends Vue {
  @Prop({ type: Boolean, default: false })
  private disabled: boolean
  @Prop({ type: String })
  private tipo: string
}
